export const NAMESPACES_CONSTANTS = {
  COMMON: 'common',
  HOME: 'home',
  AUTH: 'auth',
  SEARCH: 'search',
  PROFILE: 'profile',
  BOOKING: 'booking',
};